import React from "react";

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a
        href="https://www.linkedin.com/in/itsang/"
        className="home__social-link"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-linkedin-in"></i>
      </a>

      <a
        href="https://github.com/ivntsng"
        className="home__social-link"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-github"></i>
      </a>

      <a
        href="/assets/Ivan_Tsang_Resume.pdf"
        className="home__social-link"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-solid fa-file-lines"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
